import React from 'react';

import {
  Select,
  MenuItem,
  Typography,
  FormControl,
  InputLabel,
  styled,
} from '@mui/material';

const Wrapper = styled('div')({
  '& .MuiInputBase-root': {
    // minHeight: '42px',
    maxHeight: '44px',
  },
  '& MuiInputBase-input': {
    fontSize: '26px',
    color: '#333333',
  },
  '& .MuiSelect input': {
    padding: '6px 0 7px',
  },
  '& .MuiSelect-select': {
    paddingBottom: '5px',
  },
  '& .MuiInputLabel-outlined': {
    // transform: 'translate(14px, 20px) scale(1)',
    fontFamily: 'Suisse-Intl',
    fontSize: '21px',
    color: '#333333 !important',
  },
  '& .MuiInputLabel-outlined.Mui-disabled': {
    color: '#919eab !important',
  },
  '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
    // transform: 'translate(0px, -6px) scale(0.75)',
  },
  '& .MuiInput-underline::before': {
    borderBottom: '2px solid #333333',
    top: '36px',
    zIndex: 1,
  },
  '& .MuiInput-underline.Mui-disabled:before': {
    borderBottomStyle: `solid`,
    borderBottomColor: '#919eab',
  },
});

/* eslint-disable */
export const SdmSelectV5 = ({
  options,
  labelKey,
  label,
  optionDescriptionCallback,
  resetLabel = '-',
  onSelect,
  value,
  disabled,
  disabledLabel,
  customStyle,
  inputProps = {},
}) => {
  return (
    <Wrapper style={customStyle}>
      <FormControl fullWidth disabled={disabled}>
        <InputLabel
          id="demo-simple-select-helper-label"
          style={{
            marginLeft: '-14px',
            fontSize: '16px !important',
            fontFamily: 'Suisse-Intl',
            color: '#333333',
          }}
        >
          {label}
        </InputLabel>
        <Select
          value={value}
          fullWidth
          onChange={onSelect}
          variant="standard"
          inputProps={inputProps}
          style={{
            fontFamily: 'Suisse-Intl',
            fontSize: '20px',
            lineHeight: '28px',
            color: '#333333',
          }}
        >
          {options
            ? options.map((option, idx) => (
                <MenuItem key={idx} value={option.value}>
                  <Typography
                    margin={0}
                    style={{
                      fontFamily: 'Suisse-Intl',
                      fontSize: '20px',
                      lineHeight: '28px',
                      color: '#333333',
                    }}
                    fontFamily={'Suisse-Intl'}
                  >
                    {option[`${labelKey}`]}
                  </Typography>
                </MenuItem>
              ))
            : null}
        </Select>
      </FormControl>
    </Wrapper>
  );
};
